module.exports = __webpack_public_path__ + "img/carousel-clientes-16.69f6ebc9.png";